"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_design_system_1 = require("@hdh-core/react-design-system");
const react_intl_1 = require("react-intl");
const transactionSigningAction_1 = require("@/features/transaction-signing/actions/transactionSigningAction");
const react_redux_1 = require("react-redux");
const TransactionSigningPrompter = ({ onClose }) => {
    const intl = (0, react_intl_1.useIntl)();
    const [isOpen, setOpen] = (0, react_1.useState)(true);
    const dispatch = (0, react_redux_1.useDispatch)();
    const closeTransactionSigningPrompter = () => {
        setOpen(false);
        dispatch((0, transactionSigningAction_1.dismissTransactionSigningPrompter)());
        onClose();
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_design_system_1.AlertDialog, { iconType: "call-center", isOpen: isOpen, setOpen: setOpen, title: intl.formatMessage({ id: 'transaction-signing-otp-text-lostChangeSecurityToken-title' }), message: intl.formatMessage({ id: 'transaction-signing-otp-text-lostChangeSecurityTokenMessage' }), onClick: closeTransactionSigningPrompter })));
};
exports.default = TransactionSigningPrompter;
